<div class="d-flex flex-wrap flex-lg-nowrap align-items-center gap-3">
  <div class="flex-grow-1 overflow-hidden">
    <div class="d-flex align-items-center">
      @if (isCheckbox()) {
        <input
          class="form-check-input action-checkbox"
          type="checkbox"
          (change)="onActionClicked()"
          [disabled]="actionButtonDisabled()"
          [checked]="isChecked()"
          [attr.data-test]="dataTest()"
        />
      }
      @if (iconPath()) {
        <div class="mr-2">
          <img ngSrc="{{ iconPath() }}" alt="" width="16" height="20" />
        </div>
      }
      <div class="flex-grow-1 overflow-hidden">
        <h2 class="d-block mb-0" [ngClass]="{ 'text-truncate': truncateTitle() }" [lang]="lang">{{ title() | translate }}</h2>
        @if (subtitle()) {
          <div class="subtitle d-flex gap-2 subtitle-text" [innerHtml]="subtitle() | translate"></div>
        }
      </div>
    </div>
  </div>
  <div class="action-card">
    @switch (infoCardType()) {
      @case (InfoCardType.BADGE) {
        <mwe-availability-badge [activeBadge]="true" [inactiveBadge]="false" [unknownBadge]="false" [hoverMessage]="'Aktiv'" />
      }
      @case (InfoCardType.ACCORDION) {
        <div class="action-chevron">
          <lib-ikp-info-card-chevron-button [(isCollapsed)]="isCollapsed" [index]="index()" />
        </div>
      }
      @case (InfoCardType.LINK) {
        @if (actionText()) {
          <div class="action-link">
            <lib-ikp-info-card-link
              [text]="actionText()"
              [color]="actionColor()"
              [icon]="actionIcon()"
              [index]="index()"
              (actionClicked)="onActionClicked()"
              [attr.data-test]="'info-card-actionlink-idx-' + index()"
            />
          </div>
        }
      }
      @case (InfoCardType.BUTTON) {
        @if (actionText()) {
          <div class="text-nowrap">
            <mwe-button
              [labelKey]="actionText()"
              [prependIconClass]="actionIcon()"
              [category]="actionButtonCategory()"
              [size]="actionButtonSize()"
              [disabled]="actionButtonDisabled()"
              (clicked)="onActionClicked()"
            />
          </div>
        }
      }
      @default {}
    }
  </div>
</div>
